// extracted by mini-css-extract-plugin
export var button = "_mx-2";
export var card = "_mx-0";
export var closeButtonContainer = "_mx-3";
export var iconContainer = "_mx-1";